import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { ListItem } from '../../ListItem'
import { ProfileFlatsWidgetItemContent } from '../ProfileFlatsWidgetItemContent'

import { isNeedToShowFlatItemIcons } from './ProfileFlatsWidgetItem.utils'

import * as styles from './ProfileFlatsWidgetItem.module.css'

import FlatIcon from '../../../icons/flat.svg'

function ProfileFlatsWidgetItem({
  className = styles.ProfileFlatsWidgetItem,
  hoverClassName = styles.hover,
  isNeedToShowIcons = isNeedToShowFlatItemIcons,
  ...restProps
}) {
  return (
    <ListItem
      {...restProps}
      Content={ProfileFlatsWidgetItemContent}
      ListIcon={FlatIcon}
      className={className}
      hoverClassName={hoverClassName}
      isNeedToShowIcons={isNeedToShowIcons}
      tooltipProps={{ placement: FLOATING_ELEMENT_PLACEMENT.top }}
    />
  )
}

export default ProfileFlatsWidgetItem
